import { FeatureCheckProvider } from '@calendly/feature-check-react'

import ErrorPage from 'components/error/page'
import { BookingBodyStylesManager } from 'product_refresh'
import { useIdentityReady } from 'contexts/IdentityContext'

import { usePackageExperimenterConfig } from './usePackageExperimenterConfig'

export const PackageUnavailableErrorPage = ({ currentUser, profile, error }) => {
  const { data: experimentConfig, isFetching } = usePackageExperimenterConfig(profile)
  const isIdentityReady = useIdentityReady()

  if (!isIdentityReady || isFetching) return null

  const {
    enabledFeatures = {},
    isAuthenticated = false,
    layers = {},
  } = experimentConfig ?? {}

  return (
    <FeatureCheckProvider
      enabledFeatures={enabledFeatures}
      layers={layers}
      isAuthenticated={isAuthenticated}
    >
      <BookingBodyStylesManager />
      <ErrorPage
        current_user={currentUser}
        profile={profile}
        error={error}
      />
    </FeatureCheckProvider>
  )
}
